module.exports = __webpack_public_path__ + "static/media/resources.89231355.svg";